import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import BannedWord from "../BannedWord.vue";

export default Node.create({
    name: "BannedWord",
    inline: true,
    group: "inline",
    addAttributes() {
        return {
            word: {
                default: "word",
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: "banned-word",
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ["banned-word", mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(BannedWord);
    },
});
